module.exports = __webpack_public_path__ + "media/images/icons/linkedin_white_login-90a37306dd476d68d0dc6d002bfcbd76.svg";